export default __webpack_public_path__ + "static/media/ES_Appointment.2551a427.svg";